<component v-if="shouldRenderConfig" v-bind:is="getContainerType" v-bind:class="getClassName">
    <appPageOptionAttributes
        v-for="(pageOptionAttributes,index) in getProductPageOptionValues"
        v-bind:key="index"
        v-bind:propsData="pageOptionAttributes"
        v-if="!isRange"
    ></appPageOptionAttributes>    
    <appRangeAttribute v-if="isRange" v-bind:code="code" v-bind:propsData="getRangeData"></appRangeAttribute>
    <appInputCustomFormat v-if="code=='format'" v-bind:nrItems="getProductPageOptionValues.length"></appInputCustomFormat>
</component>
